import axiosProtected from "../../api/config/baseWithToken";

// Counts the API requests in flight and names the newest one, for the loading pill.
// Requests that have their own feedback (the sync toast) or run in the background are left out.
// The tracking page preview and the sidebar's tracking page check run in the background too.
const SKIP = /notifications|spend-rate|orders\?sync=yes|tracking-page/;

const LABELS = [
  [/dashboard-summary/, "Loading your dashboard…"],
  [/order-trackings/, "Loading shipments…"],
  [/dispute/, "Loading disputes…"],
  [/returned/, "Loading returns…"],
  [/\/store\/orders|\/orders\//, "Loading orders…"],
  [/product/, "Loading products…"],
  [/wallet|transaction|payment|topup/, "Loading payments…"],
  [/store|user/, "Loading your account…"],
];

const pending = new Map();
const listeners = new Set();
let seq = 0;

const emit = () => {
  const list = [...pending.values()];
  const label = list.length ? list[list.length - 1] : null;
  listeners.forEach((fn) => fn(label));
};

const labelFor = (config) => {
  if ((config.method || "get").toLowerCase() !== "get") return "Saving…";
  const url = config.url || "";
  return (LABELS.find(([re]) => re.test(url)) || [null, "Loading…"])[1];
};

let installed = false;
export function installLoadingTracker() {
  if (installed) return;
  installed = true;
  axiosProtected.interceptors.request.use((config) => {
    if (!SKIP.test(config.url || "")) {
      config.usendLoadingId = ++seq;
      pending.set(config.usendLoadingId, labelFor(config));
      emit();
    }
    return config;
  });
  const done = (config) => {
    if (config?.usendLoadingId && pending.delete(config.usendLoadingId)) emit();
  };
  axiosProtected.interceptors.response.use(
    (response) => {
      done(response.config);
      return response;
    },
    (error) => {
      done(error?.config);
      return Promise.reject(error);
    }
  );
}

// Installed on import so requests fired by a page's first render are counted too.
installLoadingTracker();

export function subscribeLoading(fn) {
  listeners.add(fn);
  if (pending.size) fn([...pending.values()].pop());
  return () => listeners.delete(fn);
}
